import React, { useCallback, useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Spinner,
} from "reactstrap";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import Select from "react-select";

import {
  getDashboardSalidas,
  reportTicketPublic,
  resourcesBranch,
  resourcesReports,
} from "../../../helpers/backend_helper";
import PreviewPDF from "../../../helpers/previewPDF";

const SalidasDashboard = () => {
  const { route_slug } = useParams();

  const [type, setType] = useState("arrive");
  const [route, setRoute] = useState();
  const [error, setError] = useState("");
  const [salidas, setSalidas] = useState([]);
  const [salidasDepart, setSalidasDepart] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(100);
  const [modalPdf, setModalPdf] = useState({ show: false, url: "" });
  const [ramales, setRamales] = useState([]);
  const [filters, setFilters] = useState({
    branch_id: "",
  });

  const fetchDashboardData = useCallback(async () => {
    try {
      const data = await getDashboardSalidas(route_slug, { params: filters });
      if (!data) return;

      setSalidas(data.salidas);
      setSalidasDepart(data.salidasDepart || []);
      setRoute(data.route);
    } catch (error) {
      setError(error?.message ?? "Error desconocido");
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [filters]);

  const timerRefreshData = async () => {
    setIsRefreshing(true);

    await fetchDashboardData();

    setIsRefreshing(false);
    setTimeRemaining(60);
  };

  const timerSeconds = () => {
    setTimeRemaining((prevTime) => prevTime - 1);
  };

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData, filters]);

  useEffect(() => {
    const timer = setInterval(timerRefreshData, 60000);
    const intervalId = setInterval(timerSeconds, 1000);

    return () => {
      clearInterval(timer);
      clearInterval(intervalId);
    };
  }, [fetchDashboardData]);

  useEffect(() => {
    const config = { params: { route_slug } };

    resourcesBranch("get", config).then((response) => {
      setRamales([{ id: "", name: "Todos" }, ...response.data]);
    });
  }, []);

  const printTicket = async (salidaId) => {
    let config = {
      params: { salida_id: salidaId },
      headers: {
        Accept: "application/pdf",
      },
      responseType: "blob",
    };
    const ticket = await reportTicketPublic(config);
    let nombre = "Archivo";
    var reader = new FileReader();
    reader.readAsDataURL(ticket);
    reader.fileName = nombre[1] || nombre[0];
    reader.onloadend = function (name) {
      name = nombre[0];
      var base64data = reader.result;
      setModalPdf({ show: true, url: base64data });
    };
  };

  if (isLoading)
    return (
      <div>
        <div className="maintenance-cog-icon text-primary pt-4 text-center">
          <i className="mdi mdi-cog spin-right display-3"></i>
          <i className="mdi mdi-cog spin-left display-4 cog-icon"></i>
          <p className="text-dark"></p>
          <h3 className="mt-4">Cargando información de la ruta</h3>
          <p className="text-dark">Espere un momento por favor</p>
        </div>
      </div>
    );

  if (!route)
    return (
      <p className="text-center py-4">No se encontro información de la ruta</p>
    );

  if (error) return <p className="text-center py-4">Error: {error}</p>;

  return (
    <React.Fragment>
      <div className="bg-soft-light min-vh-100">
        <div className="bg-primary py-3">
          <Container fluid={true}>
            <div className="row">
              <div className="col-12 col-md-4 text-center text-md-start">
                <span className="logo-txt pe-2">GoGoTrack</span>
              </div>
              <div className="col-12 col-md-4">
                <h4 className="fw-medium display-7 mb-0  text-center">
                  Salidas {route?.name}
                </h4>
              </div>
              <div className="col-12 col-md-4 text-center text-md-end">
                {isRefreshing ? (
                  <div className="text-end pe-2">
                    <Spinner />
                  </div>
                ) : (
                  <div className="text-end pe-2">
                    <p className="mb-0">
                      Actualizar en <b>{timeRemaining}</b>
                    </p>
                  </div>
                )}
              </div>
            </div>
          </Container>
        </div>
        <div className="pt-2">
          <Row className="mb-3">
            <Col sm={12} className="text-center">
            <label className="form-label d-inline-block me-2">Ramal:</label>
              <div className="d-inline-block mt-3 text-start me-3 mb-2" style={{ width: "300px" }}>
                <Select
                  style={{ padding: "01.25rem 0.5rem" }}
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  value={ramales.find((item) => item.id === filters.branch_id)}
                  isSearchable={false}
                  name="week"
                  placeholder="Ramal"
                  options={ramales}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option.id}`}
                  onChange={(e) => {
                    setFilters({ ...filters, branch_id: e ? e.id : "" });
                  }}
                />
              </div>
              <Button
                color={type === "depart" ? "primary" : "secondary"}
                className="btn-sm me-2"
                onClick={() => setType("depart")}
              >
                <i className="fa fas fa-arrow-up"></i> Por iniciar
              </Button>
              <Button
                color={type === "arrive" ? "primary" : "secondary"}
                className="btn-sm"
                onClick={() => setType("arrive")}
              >
                <i className="fa fas fa-arrow-down"></i> Por concluir
              </Button>
            </Col>
          </Row>
          <Container fluid={true}>
            {type === "arrive" && (
              <>
                {salidas.map((salida) => {
                  return (
                    <Row key={salida.id}>
                      <Col sm={12}>
                        <Card>
                          <CardBody>
                            <p className="mb-0 text-center pb-2">
                              <span className="font-size-16 pe-2">
                                Ramal: {salida?.branch?.name}
                              </span>
                              <span className="font-size-16 pe-2">
                                <strong>Unidad: {salida?.unit?.number}</strong>
                              </span>
                              <span className="font-size-16 text-danger pe-2">
                                <strong>Tiempo: {salida.hora}</strong>
                              </span>

                              <span className="ps-5 pe-2 text-muted">
                                Salida: {salida.no}
                              </span>
                              <span className="pe-2 text-muted">
                                Destino: {salida?.destination}
                              </span>
                              {salida.salidas_ruta.length > 0 && (
                                <>
                                  <Badge color="danger">Salida de Ruta</Badge>{" "}
                                  {dayjs(salida.salidas_ruta[0].fecha).format(
                                    "HH:mm"
                                  )}
                                </>
                              )}
                            </p>
                            <div className="table-responsive">
                              <table
                                className="table table-sm table-bordered mb-0"
                                border="1"
                                width="100%"
                              >
                                <thead
                                  className={
                                    salida.salidas_ruta.length == 0
                                      ? "table-light"
                                      : "table-danger"
                                  }
                                >
                                  <tr>
                                    <th style={{ minWidth: "100px" }}>
                                      Geocercas
                                    </th>
                                    {salida?.time_geofences?.map(
                                      ({ id, geofence_name }) => (
                                        <th key={id}>{geofence_name}</th>
                                      )
                                    )}
                                    <th style={{ minWidth: "100px" }}>
                                      Min. Quemados
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="row">Programado</th>
                                    {salida?.tiempos?.map(
                                      ({ id, tiempo_propuesto }) => (
                                        <td className="text-center" key={id}>
                                          {tiempo_propuesto
                                            ? tiempo_propuesto ?? "-"
                                            : "-"}
                                        </td>
                                      )
                                    )}
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Real</th>
                                    {salida?.tiempos?.map(
                                      ({ id, tiempo_real, diferencia }) => (
                                        <td className="text-center" key={id}>
                                          {tiempo_real ? tiempo_real : "-"}
                                          <br />
                                          {diferencia > 0
                                            ? ` (+${diferencia})`
                                            : ""}
                                        </td>
                                      )
                                    )}
                                    <td>{salida?.min_quemados}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  );
                })}
                {!salidas.length ? (
                  <Row>
                    <Col sm={12}>
                      <Card>
                        <CardBody>
                          <div className="d-flex justify-content-between align-items-cente">
                            <p className="display-7 mb-0">
                              No se encontraron salidas
                            </p>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                ) : null}
              </>
            )}
            {type === "depart" && (
              <>
                <table
                  className="table table-sm table-bordered mb-0"
                  border="1"
                  width="100%"
                >
                  <thead className="table-light">
                    <tr>
                      <th style={{ minWidth: "100px" }}>Salida</th>
                      <th style={{ minWidth: "100px" }}>Hora</th>
                      <th style={{ minWidth: "100px" }}>Unidad</th>
                      <th style={{ minWidth: "100px" }}>Destino</th>
                      <th style={{ minWidth: "100px" }}>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {salidasDepart.map((salida) => {
                      return (
                        <tr key={salida.id}>
                          <td>{salida.no}</td>
                          <td>{salida?.date_time.substring(11)}</td>
                          <td>{salida?.unit_number}</td>
                          <td>{salida?.destination}</td>
                          <td>
                            <Button
                              size={"sm"}
                              onClick={() => printTicket(salida.id)}
                            >
                              <i className="fa fas fa-print"></i> Imprimir
                              Ticket
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {!salidasDepart.length ? (
                  <Row>
                    <Col sm={12}>
                      <Card>
                        <CardBody>
                          <div className="d-flex justify-content-between align-items-cente">
                            <p className="display-7 mb-0">
                              No se encontraron salidas
                            </p>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                ) : null}
              </>
            )}
            {modalPdf.show && (
              <PreviewPDF
                title="Ticket"
                modalPdf={modalPdf}
                setModalPdf={setModalPdf}
              />
            )}
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SalidasDashboard;
